import React from 'react';
import BaseTemplate from './base.js';
import SideImageTemplate from './side_image.js';

/*---------------------------------------------*/

export default class SideImageBubbleTemplate extends BaseTemplate {
	render() {
		return (
			<SideImageTemplate bubble={true} {...this.props} />
		)
	}
}

/*---------------------------------------------*/
